import PropTypes from 'prop-types';
import { withHandlers, compose } from 'recompose';
import { reduxForm, SubmissionError } from 'redux-form';
import React from 'react';
import Modal from '../../../common/Modal';
import Input from '../../../common/input';
import CancelButton from '../../../common/buttons/cancelButton';
import SaveButton from '../../../common/buttons/saveButton';
import { t } from '../../../../modules/infra/i18n';

const Form = ({ handleSubmit, onCancel }) => (
  <form className="layout u-p+ " onSubmit={handleSubmit}>
    <div className="layout__item u-mb+">
      <span className="c-label-new">{t('register:summary.passcode_modal.enter_passcode')}</span>
      <Input
        className="c-input c-masked-input"
        name="passcode"
        type="number"
        inputmode="tel"
        autocomplete="off"
        placeholder="0000"
      />
    </div>
    <div className="layout__item u-text-right">
      <CancelButton content={t('common:modal.cancel_button')} onClick={onCancel} />
      <SaveButton content={t('common:modal.confirm_button')} />
    </div>
  </form>
);

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const TIME_TRACKING_FORM = 'CHECK_SHOP_PERMISSION_PASSCODE_FORM';

const CheckShopPermissionPasscodeForm = compose(
  withHandlers({
    onSubmit: props => ({ passcode }) => {
      const isValid = props.checkPasscode(passcode);

      if (!isValid) {
        throw new SubmissionError({ passcode: t('register:summary.passcode_modal.invalid_passcode') });
      }
    },
  }),
  reduxForm({
    form: TIME_TRACKING_FORM,
  }),
)(Form);

const CheckShopPermissionPasscodeModal = props => (
  <Modal
    showCloseButton
    close={props.onClose}
  >
    <CheckShopPermissionPasscodeForm
      onCancel={props.onClose}
      checkPasscode={props.checkPasscode}
    />
  </Modal>
);

CheckShopPermissionPasscodeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  checkPasscode: PropTypes.func.isRequired,
};

export default CheckShopPermissionPasscodeModal;
